import React from 'react';
import Icon from './ui/Icon';
import './VoiceAssistantTrigger.css';

interface VoiceAssistantTriggerProps {
  onClick: () => void;
  isRecording?: boolean;
}

const VoiceAssistantTrigger: React.FC<VoiceAssistantTriggerProps> = ({ onClick, isRecording = false }) => {
  return (
    <div className="voice-assistant-trigger">
      <button
        onClick={onClick}
        className={`voice-trigger-button ${isRecording ? 'recording' : ''}`}
        title={isRecording ? 'Stop Recording' : 'Start Voice Assistant'}
        aria-label={isRecording ? 'Stop Recording' : 'Start Voice Assistant'}
      >
        {isRecording ? (
          <Icon name="mic-stop" size={28} className="icon-mic-stop" />
        ) : (
          <Icon name="mic" size={28} className="icon-mic" />
        )}
      </button>
    </div>
  );
};

export default VoiceAssistantTrigger;

